const HeartBeatMessageType=4

let HeartBeatMessage = function (){
	this.messageType=HeartBeatMessageType
}

export {
	HeartBeatMessage
}